<div id="min-amb-container">
    <wecmp-transversales-header [needLogin]="true"></wecmp-transversales-header>
    <app-menu></app-menu>
    <router-outlet></router-outlet>

    <wecmp-transversales-footer [esVentanilla]="true"></wecmp-transversales-footer>
    <wecmp-transversales-accessibility-bar></wecmp-transversales-accessibility-bar>
</div>